export var LocalStorageKeyEnum;
(function (LocalStorageKeyEnum) {
    LocalStorageKeyEnum["PENDINGREQ"] = "PENDINGREQ";
    LocalStorageKeyEnum["ACCOUNTS"] = "accounts";
    LocalStorageKeyEnum["ACCOUNTS_HIVE"] = "accountshive";
    LocalStorageKeyEnum["ACCOUNTS_BLURT"] = "accountsblurt";
    LocalStorageKeyEnum["RPC_LIST"] = "rpc";
    LocalStorageKeyEnum["CURRENT_RPC"] = "current_rpc";
    LocalStorageKeyEnum["ACTIVE_ACCOUNT_NAME"] = "active_account_name";
    LocalStorageKeyEnum["FAVORITE_USERS"] = "transfer_to";
    LocalStorageKeyEnum["KEYCHAINIFY_ENABLED"] = "keychainify_enabled";
    LocalStorageKeyEnum["CLAIM_REWARDS"] = "claimRewards";
    LocalStorageKeyEnum["CLAIM_ACCOUNTS"] = "claimAccounts";
    LocalStorageKeyEnum["CLAIM_SAVINGS"] = "claimSavings";
    LocalStorageKeyEnum["AUTOLOCK"] = "autolock";
    LocalStorageKeyEnum["NO_CONFIRM"] = "no_confirm";
    LocalStorageKeyEnum["WALLET_HISTORY_FILTERS"] = "walletHistoryFilters";
    LocalStorageKeyEnum["HIDDEN_TOKENS"] = "hidden_tokens";
    LocalStorageKeyEnum["LOCAL_STORAGE_VERSION"] = "LOCAL_STORAGE_VERSION";
    LocalStorageKeyEnum["__MK"] = "__MK";
    LocalStorageKeyEnum["IS_LOCKED"] = "IS_LOCKED";
    LocalStorageKeyEnum["__REQUEST_HANDLER"] = "__REQUEST_HANDLER";
    LocalStorageKeyEnum["SWITCH_RPC_AUTO"] = "switchRpcAuto";
    LocalStorageKeyEnum["HIDE_SUGGESTION_PROXY"] = "HIDE_SUGGESTION_PROXY";
    LocalStorageKeyEnum["LAST_VERSION_UPDATE"] = "LAST_VERSION_UPDATE";
    LocalStorageKeyEnum["LAST_NAME_UPDATE"] = "LAST_NAME_UPDATE";
    LocalStorageKeyEnum["LAST_DESCRIPTION_UPDATE"] = "LAST_DESCRIPTION_UPDATE";
    LocalStorageKeyEnum["STEEM_ENGINE_CUSTOM_RPC_LIST"] = "STEEM_ENGINE_CUSTOM_RPC_LIST";
    LocalStorageKeyEnum["STEEM_ENGINE_CUSTOM_ACCOUNT_HISTORY_API"] = "STEEM_ENGINE_CUSTOM_ACCOUNT_HISTORY_API";
    LocalStorageKeyEnum["STEEM_ENGINE_ACTIVE_CONFIG"] = "STEEM_ENGINE_ACTIVE_CONFIG";
    LocalStorageKeyEnum["ANALYTICS_SETTINGS"] = "ANALYTICS_SETTINGS";
    LocalStorageKeyEnum["GA_CLIENT_ID"] = "GA_CLIENT_ID";
    LocalStorageKeyEnum["ANALYTICS_FIRST_ACCOUNT_EVENT_SENT"] = "ANALYTICS_FIRST_ACCOUNT_EVENT_SENT";
    LocalStorageKeyEnum["GOVERNANCE_RENEWAL_IGNORED"] = "GOVERNANCE_RENEWAL_IGNORED";
    LocalStorageKeyEnum["SURVEY_INFO"] = "SURVEY_INFO";
    LocalStorageKeyEnum["SWAP_LAST_USED_TOKENS"] = "SWAP_LAST_USED_TOKENS";
    LocalStorageKeyEnum["NO_KEY_CHECK"] = "NO_KEY_CHECK";
    LocalStorageKeyEnum["WITNESS_LAST_SIGNING_KEY"] = "WITNESS_LAST_SIGNING_KEY";
    LocalStorageKeyEnum["LAST_PRICE"] = "LAST_PRICE";
    LocalStorageKeyEnum["MULTISIG_CONFIG"] = "MULTISIG_CONFIG";
    LocalStorageKeyEnum["LAST_VESTING_ROUTES"] = "LAST_VESTING_ROUTES";
    LocalStorageKeyEnum["PORTFOLIO_FILTER"] = "PORTFOLIO_FILTER";
    LocalStorageKeyEnum["PROPOSAL_SKIPPED"] = "PROPOSAL_SKIPPED";
    // Global keys
    LocalStorageKeyEnum["ACTIVE_CHAIN"] = "ACTIVE_CHAIN";
    LocalStorageKeyEnum["ACTIVE_THEME"] = "ACTIVE_THEME";
    // To show the right type of account value
    LocalStorageKeyEnum["ACCOUNT_VALUE_TYPE"] = "ACCOUNT_VALUE_TYPE";
    LocalStorageKeyEnum["VALUE_TYPE1"] = "VALUE_TYPE1";
    LocalStorageKeyEnum["VALUE_TYPE2"] = "VALUE_TYPE2";
    // To check if some account (regardless of chain) has been setup
    LocalStorageKeyEnum["HAS_FINISHED_SIGNUP"] = "HAS_FINISHED_SIGNUP";
    // Onboard Tutorial
    LocalStorageKeyEnum["SKIP_TUTORIAL"] = "SKIP_TUTORIAL";
    //Auto Stake Engine Tokens
    LocalStorageKeyEnum["LAYER_TWO_AUTO_STAKE"] = "LAYER_TWO_AUTO_STAKE";
    LocalStorageKeyEnum["LAYER_TWO_AUTO_STAKE_TOKENS"] = "LAYER_TWO_AUTO_STAKE_TOKENS";
})(LocalStorageKeyEnum || (LocalStorageKeyEnum = {}));
